<template>
  <el-dialog
    append-to-body
    class="upDialog"
    :title="info.title"
    :visible.sync="visibleDialog"
    width="50%"
    :destroy-on-close="true"
    @close="closeHandle(true)"
  >
    <el-upload
      class="upload-multi-media"
      :with-credentials="true"
      :accept="info.accept"
      drag
      action="/fill/api/v1/upload"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :on-remove="uploadRemove"
      :before-upload="beforeUpload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">只能上传{{info.msg}}文件，且不超过100Mb</div>
    </el-upload>
    <footer slot="footer" class="dialog-footer">
      <el-button @click="visibleDialog = false">取 消</el-button>
      <el-button type="primary" :loading="uploadLoading" @click="confirmHandle()">确 定</el-button>
    </footer>
  </el-dialog>
</template>

<script>
export default {
  name: 'AddMediaDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    addType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      uploadImageFiles: [],
      uploadAudioFiles: [],
      uploadVideoFiles: [],
      uploadLoading: false,
    }
  },
  computed: {
    visibleDialog: {
      get() {
        return this.visible;
      },
      set(bool) {
        this.$emit('update:visible', bool);
      }
    },
    info() {
      switch(this.addType) {
        case 'audio':
          return {
            title: '新增音频',
            accept: 'audio/aac',
            msg: 'aac',
          };
        case 'video':
          return {
            title: '新增视频',
            accept: 'video/mp4',
            msg: 'mp4',
          };
        case 'image':
          return {
            title: '新增全局图片',
            accept: 'image/jpeg',
            msg: 'jpg/jpeg',
          };
        default:
          return {
            title: '新增',
            accept: '*',
            msg: '任何'
          }
      }
    }
  },
  methods: {
    uploadSuccess(res, file, fileList) {
      const { msg, code } = res || {};
      if (code === 0) {
        this.addMediaList(file);
      } else {
        const delIndex = fileList.findIndex(f => f.uid === file.uid);
        if (delIndex > -1) {
          fileList.splice(delIndex, 1);
        }
        this.$message.error(msg ?? '上传失败');
      }
      this.uploadLoading = false;
    },
    uploadError(err) {
      this.$message.error(err?.msg ?? '上传失败');
      this.uploadLoading = false;
    },
    uploadRemove(file) {
      const { url } = file?.response?.data || {};
      switch(this.addType) {
        case 'audio': {
          const aduIndex = this.uploadAudioFiles.findIndex(f => f.url === url);
          if (aduIndex > -1) {
            this.uploadAudioFiles.splice(aduIndex, 1);
          }
          break;
        }
        case 'video': {
          const vduIndex = this.uploadVideoFiles.findIndex(f => f.url === url);
          if (vduIndex > -1) {
            this.uploadVideoFiles.splice(vduIndex, 1);
          }
          break;
        }
        case 'image': {
          const imgIndex = this.uploadImageFiles.findIndex(f => f.url === url);
          if (imgIndex > -1) {
            this.uploadImageFiles.splice(imgIndex, 1);
          }
          break;
        }
      }
    },
    beforeUpload(file) {
      const isLt100M = file.size / 1024 / 1024 / 100 < 1;
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 100MB!');
        return false;
      }
      switch (this.addType) {
        case 'video': {
          if (file.type !== 'video/mp4') {
            this.$message.error('只能上传mp4文件');
            return false;
          }
          break;
        }
        case 'audio': {
          if (file.type !== 'audio/aac' && file.type !== 'audio/vnd.dlna.adts') {
            this.$message.error('只能上传aac文件');
            return false;
          }
          break;
        }
        case 'image': {
          if (file.type !== 'image/jpeg') {
            this.$message.error('只能上传jpg/jpeg文件');
            return false;
          }
          break;
        }
      }
      this.uploadLoading = true;
      return true;
    },
    addMediaList(file) {
      const { url, fileName } = file?.response?.data || {};
      switch(this.addType) {
        case 'audio':
          this.uploadAudioFiles.push({
            key: `audio_${Date.now()}`,
            url: url ?? '',
            fileName: fileName ?? '音频',
          });
          break;
        case 'video':
          this.uploadVideoFiles.push({
            key: `video_${Date.now()}`,
            url: url ?? '',
            fileName: fileName ?? '视频',
          });
          break;
        case 'image':
          this.uploadImageFiles.push({
            key: `image_${Date.now()}`,
            url: url ?? '',
            fileName: fileName ?? '图片',
          });
          break;
      }
    },
    closeHandle(isEmit = true) {
      this.uploadImageFiles.splice(0);
      this.uploadAudioFiles.splice(0);
      this.uploadVideoFiles.splice(0);
      if (isEmit) {
        this.$emit('close');
      }
    },
    confirmHandle() {
      const image = JSON.parse(JSON.stringify(this.uploadImageFiles));
      const audio = JSON.parse(JSON.stringify(this.uploadAudioFiles));
      const video = JSON.parse(JSON.stringify(this.uploadVideoFiles));
      this.$emit('confirm', {
        type: this.addType,
        image,
        audio,
        video,
      });
      this.closeHandle(false);
    }
  }
}
</script>

<style lang="scss" scoped>
.upDialog {
  .upload-multi-media {
    text-align: center;
  }
}
</style>